import './service.css'

const Service = () => {
  return (
    <section id='service'>
      <h2>Academic Service</h2>
      <div className="service_grid">
        <article>
          <span className="service_label">Journal Reviewer</span>
          <h3>TOIS, TAI</h3>
          {/* <p>Served as a reviewer for ACM Transactions on Information Systems.</p> */}
        </article>
        <article>
          <span className="service_label">Conference Reviewer</span>
          <h3>NeurIPS, AAAI, CIKM, WWW</h3>
          {/* <p>Served as a program committee member / reviewer for major AI, web, and information retrieval conferences.</p> */}
        </article>
      </div>
    </section>
  )
}

export default Service
